/**
 * @generated SignedSource<<8897b52c1ca00731407e2f52b2eedd1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Title_artist$data = {
  readonly displayName: string;
  readonly slug: string;
  readonly " $fragmentType": "Title_artist";
};
export type Title_artist$key = {
  readonly " $data"?: Title_artist$data;
  readonly " $fragmentSpreads": FragmentRefs<"Title_artist">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Title_artist",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    }
  ],
  "type": "ArtistNode",
  "abstractKey": null
};

(node as any).hash = "bcc954014708e94f8d4ef4b961317d18";

export default node;
